import { Badge } from "antd";
import { BellFilled, BellOutlined } from '@ant-design/icons';
import { Link, useNavigate, useLocation } from "react-router-dom";
import React from "react";
import "./style.scss";
import { connect } from "react-redux";
import { showConfirmationTab } from "Misc/utils";

const UrgencyBadge = ({ urgencyCount, unsaved }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollTop = () => {
    const el = document.querySelector(
      ".layout-painel .layoutColuna .coluna-overflow"
    );
    if (el)
      el.scrollTo({
        top: 0,
        behavior: "smooth",
      });
  };

  const showConfirm = (answers) => {
    if (
      !(
        location.pathname.startsWith("/rotina") ||
        location.pathname.startsWith("/ausencia") ||
        location.pathname.startsWith("/atendimento") ||
        location.pathname.startsWith("/pacientes") ||
        location.pathname.startsWith("/urgencia") 
      )
    ) {
      if (!location.pathname.startsWith("/painel")) navigate("/painel")
      scrollTop();
      return;
    }
    const auxArray = [];
    Object.keys(unsaved).forEach((item) => {
      if (unsaved[item]) {
        auxArray.push(item);
      }
    });

    if (auxArray.length > 0) {
      return showConfirmationTab(
        auxArray,
        () => {
          navigate("/painel");
          scrollTop();
        },
        () => {},
        "Ao sair da página, as alterações não serão salvas. Deseja continuar mesmo assim?",
        "Sim, continuar"
      );
    } else {
      navigate("/painel");
      scrollTop();
    }
  };

  return (
    <div
      className={"urgency-badge " + (urgencyCount > 0 && "animated")}
      style={{ marginRight: "1rem" }}
    >
      <Link disabled={urgencyCount > 0 ? false : true} onClick={showConfirm}>
        <Badge count={urgencyCount}>
          {urgencyCount > 0 ? (
            <BellFilled
              style={{
                fontSize: "1.5rem",
                color: "#f5222d",
              }}
            />
          ) : (
            <BellOutlined
              style={{
                fontSize: "1.2rem",
                color: "rgba(85, 85, 85, .5)",
              }}
            />
          )}
        </Badge>
      </Link>
    </div>
  );
};

// export default UrgencyBadge;

const mapStateToProps = (store) => ({
  unsaved: store.rotina.unsaved,
});

export default connect(mapStateToProps)(UrgencyBadge);
